import { SpreadDisplay as SpreadDisplayWrapper } from '@src/components/Ladder/styles';
import { setAlpha } from '@talos/kyoko';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 30px;
  height: 50px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
`;

export const Container = styled.div<{ direction: number; showShadow?: boolean }>`
  height: 100%;
  padding-top: ${({ direction }) => (direction < 0 ? '18px' : '0px')};

  svg {
    transition: transform 0.25s linear;
    will-change: transform;
    display: block;
    transform-origin: center bottom;

    ${({ theme, showShadow }) =>
      showShadow && `filter: drop-shadow(0px -2px 1px ${setAlpha(0.8, theme.colors.gray.main)});`}
  }

  g {
    will-change: fill;
    transition: fill 0.25s linear;
  }
`;

export const SpreadDisplay = styled(SpreadDisplayWrapper)`
  p {
    font-size: ${({ theme }) => theme.fontSizeTiny}rem;
    background: ${({ theme }) => theme.colors.white.mute};
  }
`;
